/**
 * Inline component tags handled by mdxish-inline-components.ts.
 * Also excluded from block-level handling in mdxish-component-blocks.ts.
 */
export const INLINE_COMPONENT_TAGS = new Set(['Anchor']);
